/**
 * Histórico do setor (tarefas ou peças, até 500) para as visões de lista
 * (tabela, calendário, linha do tempo): o /estado só traz o que está aberto
 * e o que foi encerrado nas últimas 24 h — sem isto, a tarefa ou a peça
 * concluída ontem sumia da tabela do setor.
 *
 * `listar(request, filtros)` é a função do service (listarTarefas /
 * listarPecas). Relê quando o estado muda (`atualizacao`) e junta com os
 * `atuais` do estado, que são mais novos. Desligado (`ativo: false`)
 * devolve null e nada é buscado.
 */
import { useEffect, useMemo, useState } from "react";

import { useAuth } from "../../../context/AuthContext";
import { mesclarPorId } from "./modelo";

export default function useHistoricoDoSetor({ listar, setorId, ativo, atualizacao, atuais }) {
  const { request } = useAuth();
  const [historico, setHistorico] = useState(null);

  useEffect(() => {
    if (!ativo || !setorId) return undefined;
    let vivo = true;
    Promise.resolve()
      .then(() => listar(request, { setor_id: setorId }))
      .then((lista) => {
        if (vivo) setHistorico(Array.isArray(lista) ? lista : []);
      })
      .catch(() => {
        // Sem o histórico a tela segue com o que veio do /estado.
        if (vivo) setHistorico(null);
      });
    return () => {
      vivo = false;
    };
  }, [request, listar, setorId, ativo, atualizacao]);

  return useMemo(
    () => (ativo && historico ? mesclarPorId(historico, atuais) : null),
    [ativo, historico, atuais]
  );
}
